import {httpPost} from "../../config/request";
// 查询系统设置
export function getBaseSystemSetInfoByPlatId(params) {
    return httpPost('/base/baseRuleSet/getBaseSystemSetInfoByPlatId', params)
}
// 查询系统设置
export function getBaseSystemSetChildInfoByPlatIdApi(params) {
    return httpPost('/base/baseRuleSet/getBaseSystemSetChildInfoByPlatId', params)
}